import round from "lodash/round";

export const roundToDecimals = (number: number, decimals = 2): number => round(number, decimals);
